'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarListInfo = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _utilsList = require('@bibliocommons/utils-list');

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

require('../styles/ToolbarListInfo.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToolbarListInfo = exports.ToolbarListInfo = function (_BcReactComponent) {
  _inherits(ToolbarListInfo, _BcReactComponent);

  function ToolbarListInfo(props) {
    _classCallCheck(this, ToolbarListInfo);

    var _this = _possibleConstructorReturn(this, (ToolbarListInfo.__proto__ || Object.getPrototypeOf(ToolbarListInfo)).call(this, props));

    _this.bindAll('renderTitle', 'renderDescription');
    return _this;
  }

  _createClass(ToolbarListInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoFocus && this._toolbarTitle) {
        this._toolbarTitle.focus();
      }
    }
  }, {
    key: 'getAutosaveStatus',
    value: function getAutosaveStatus() {
      if (this.props.saving) {
        return 'saving';
      }

      return this.props.failedToSave ? 'failed' : 'saved';
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      if (!(0, _utilsList.isNewList)(this.props.list)) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_state_draft' });
      }
      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_new_list' });
    }
  }, {
    key: 'renderDescription',
    value: function renderDescription() {
      if (!(0, _utilsList.isNewList)(this.props.list)) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_autosave_' + this.getAutosaveStatus() });
      }

      var key = (0, _utilsList.isReadalikeList)(this.props.list) ? 'user_list_editor_readalike_get_started' : 'user_list_editor_generic_get_started';

      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: key });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'cp-user-list-toolbar-list-info title-block' },
        _react2.default.createElement(
          'h1',
          {
            className: 'title',
            tabIndex: '-1',
            ref: function ref(element) {
              _this2._toolbarTitle = element;
            },
            'data-test-id': 'list-toolbar-title' },
          this.renderTitle()
        ),
        _react2.default.createElement(
          'p',
          { className: 'details' },
          _react2.default.createElement(
            'span',
            {
              className: 'description',
              'data-test-id': 'list-toolbar-description',
              role: 'status',
              'aria-live': 'polite',
              'aria-atomic': 'true' },
            this.renderDescription()
          )
        )
      );
    }
  }]);

  return ToolbarListInfo;
}(_baseBcReactComponent2.default);

ToolbarListInfo.propTypes = {
  list: _bcPropTypes.listShape.isRequired,
  saving: _react.PropTypes.bool.isRequired,
  failedToSave: _react.PropTypes.bool.isRequired,
  handleSaveAsDraft: _react.PropTypes.func.isRequired,
  autoFocus: _react.PropTypes.bool
};

exports.default = ToolbarListInfo;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/toolbar-list-info/components/ToolbarListInfo.component.js
// module id = 1345
// module chunks = 0